(() => {
  const DURATION = 400;
  const EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

  function animateHeight(el, from, to, onDone) {
    el.style.overflow = 'hidden';
    el.style.height = `${from}px`;
    // Force reflow so the browser registers the start height
    void el.offsetHeight;
    el.style.transition = `height ${DURATION}ms ${EASING}`;
    el.style.height = `${to}px`;

    let done = false;
    const finish = (event) => {
      if (done) return;
      if (event && event.target !== el) return;
      if (event && event.propertyName && event.propertyName !== 'height') return;
      done = true;
      el.removeEventListener('transitionend', finish);
      if (typeof onDone === 'function') onDone();
    };

    el.addEventListener('transitionend', finish);
    // Fallback if transitionend does not fire
    window.setTimeout(finish, DURATION + 50);
  }

  class SeoPlpDescription extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.trigger = this.querySelector('[data-seo-plp-trigger]');
      this.panel = this.querySelector('[data-seo-plp-panel]');
      this.isOpen = false;
      this.isAnimating = false;

      if (!this.trigger || !this.panel) return;

      this.panel.style.height = '0px';
      this.panel.style.overflow = 'hidden';

      this.trigger.addEventListener('click', () => this.toggle());
    }

    toggle() {
      if (this.isAnimating) return;
      this.isOpen ? this.close() : this.open();
    }

    open() {
      this.isAnimating = true;
      this.isOpen = true;
      this.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');

      const endHeight = this.panel.scrollHeight;

      animateHeight(this.panel, 0, endHeight, () => {
        this.panel.style.height = 'auto';
        this.panel.style.overflow = 'visible';
        this.panel.style.transition = '';
        this.isAnimating = false;
      });
    }

    close() {
      this.isAnimating = true;
      this.isOpen = false;
      this.trigger.setAttribute('aria-expanded', 'false');

      const startHeight = this.panel.scrollHeight;

      animateHeight(this.panel, startHeight, 0, () => {
        this.classList.remove('is-open');
        this.panel.style.height = '0px';
        this.panel.style.overflow = 'hidden';
        this.panel.style.transition = '';
        this.isAnimating = false;
      });
    }
  }

  if (!customElements.get('seo-plp-description')) {
    customElements.define('seo-plp-description', SeoPlpDescription);
  }
})();
